<router-outlet></router-outlet>

<!--Global-->
<app-loader></app-loader>
<app-confirmation-dialog></app-confirmation-dialog>
<p-toast position="bottom-center" key="global" [preventOpenDuplicates]="true" />
